<template>
  <div>
    <slot :data="itemOptions">
      <el-cascader
        v-model="value"
        :options="itemOptions"
        :props="{
          value: 'Code',
          label: 'Name',
          emitPath: false,
          multiple: multiple,
        }"
        collapse-tags
        clearable
        @change="onChange"
        style="width: 100%"
      />
    </slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: this.current,
      itemOptions: [],
    };
  },
  props: {
    current: { default: null, require: false },
    typeId: { type: String, default: null, require: true },
    multiple: { type: Boolean, default: false },
  },
  created() {
    this.$apis.system.meta
      .itemList({ typeId: this.typeId })
      .then((res) => {
        this.itemOptions = res;
      })
      .catch((e) => {
        this.$message.error(e);
      });
  },
  methods: {
    onChange(val) {
      this.$emit("update:current", val);
    },
  },
};
</script>

